import { render } from "./VerifyImages.vue?vue&type=template&id=65f6f8e4&ts=true"
import script from "./VerifyImages.vue?vue&type=script&lang=ts"
export * from "./VerifyImages.vue?vue&type=script&lang=ts"

import "./VerifyImages.vue?vue&type=style&index=0&id=65f6f8e4&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__